import { render, staticRenderFns } from "./sp360datatable.vue?vue&type=template&id=58f03511&"
import script from "./sp360datatable.vue?vue&type=script&lang=js&"
export * from "./sp360datatable.vue?vue&type=script&lang=js&"
import style0 from "./sp360datatable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports